const defaultColSpan = {
  sm: 12,
  md: 6,
  lg: 4,
  xl: 3,
  xxl: 3,
};

const fullWidthColSpan = {
  sm: 12,
  md: 12,
  lg: 12,
  xl: 12,
  xxl: 12,
};

const halfWidthColSpan = {
  sm: 12,
  md: 6,
  lg: 6,
  xl: 6,
  xxl: 6,
};

const controlTypeOptions = [
  { label: "Text", value: "text" },
  { label: "Textarea", value: "textarea" },
  { label: "Number", value: "number" },
  { label: "Integer", value: "integer" },
  { label: "Decimal", value: "decimal" },
  { label: "Currency", value: "currency" },
  { label: "Percent", value: "percent" },
  { label: "Checkbox", value: "checkbox" },
  { label: "Select", value: "select" },
  { label: "Query Select", value: "queryselect" },
  { label: "Table Select", value: "tableselect" },
  { label: "Multi Select", value: "multiselect" },
  { label: "Enum Select", value: "enumselect" },
  { label: "Date", value: "date" },
  { label: "DateTime", value: "datetime" },
  { label: "Time", value: "time" },
  { label: "Year", value: "year" },
  { label: "Month", value: "month" },
  { label: "Date Range", value: "daterange" },
  { label: "File Upload", value: "fileuploadsingle" },
  { label: "Rich Text Editor", value: "editor" },
  { label: "Radio", value: "radio" },
  { label: "Pick List", value: "picklist" },
  { label: "Info", value: "info" },
];

const searchTypeOptions = [
  { label: "None", value: null },
  { label: "Contains", value: "Contains" },
  { label: "Starts With", value: "StartsWith" },
  { label: "Ends With", value: "EndsWith" },
  { label: "Equals", value: "Equals" },
];

export function getFieldOptions(
  fieldName: string,
): { label: string; value: any }[] | undefined {
  switch (fieldName) {
    case "ControlType":
    case "FilterControlType":
      return controlTypeOptions;
    case "SearchType":
      return searchTypeOptions;
    default:
      return undefined;
  }
}

export {
  defaultColSpan,
  fullWidthColSpan,
  halfWidthColSpan,
  controlTypeOptions,
};
